export default {
  BASE_URL: '/fm/invoice/register',
  api: [
    {
      name: 'list',
      desc: '列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'detail',
      desc: '明细',
      method: 'GET',
      path: '/detail'
    },
    {
      name: 'edit',
      desc: '编辑',
      method: 'POST',
      path: '/edit'
    },
    {
      name: 'modify',
      desc: '修改',
      method: 'POST',
      path: '/modify'
    },
    {
      name: 'cancel',
      desc: '作废',
      method: 'POST',
      path: '/cancel'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/outputInvoice/registration.js